import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './OnboardingWizard.css';

const ONBOARDING_KEY = 'seven_onboarding_done_v1';

export default function OnboardingWizard() {
  const navigate = useNavigate();

  const finish = () => {
    try {
      localStorage.setItem(ONBOARDING_KEY, '1');
    } catch {
      /* ignore */
    }
    navigate('/', { replace: true });
  };

  return (
    <div className="onb-wrap">
      <h1 className="onb-title">Primeros pasos en SEVEN</h1>
      <p className="onb-lead">
        Ya creamos tu primera disciplina y una sede. Sigue estos pasos para dejar tu operación lista.
      </p>
      <ul className="onb-steps">
        <li>
          <strong>Niveles y grupos</strong>
          <p>Define niveles dentro de tu disciplina y crea grupos con horario.</p>
          <Link to="/levels" className="onb-link">
            Ir a niveles
          </Link>
          <Link to="/groups" className="onb-link">
            Ir a grupos
          </Link>
        </li>
        <li>
          <strong>Profesores y staff</strong>
          <p>Invita a tu equipo con roles de profesor o secretario.</p>
          <Link to="/teachers" className="onb-link">
            Profesores
          </Link>
          <Link to="/users" className="onb-link">
            Usuarios
          </Link>
        </li>
        <li>
          <strong>Alumnos y matrículas</strong>
          <p>Registra alumnos y asígnalos a grupos.</p>
          <Link to="/students" className="onb-link">
            Alumnos
          </Link>
          <Link to="/enrollments" className="onb-link">
            Matrículas
          </Link>
        </li>
      </ul>
      <div className="onb-actions">
        <button type="button" className="onb-btn-primary" onClick={finish}>
          Ir al panel
        </button>
      </div>
    </div>
  );
}
